import { Button, ButtonGroup, Heading, Modal, Paragraph } from '@zillow/constellation-10';
import type { TourEvent } from '../../../../constants';
import { getEventToastDisplayDate } from '../../../../utils/formatTime';

type CancelTourConfirmationModalProps = {
  event: TourEvent;
  onClose: () => void;
  onCancelTourConfirmationClick: () => void;
};
const CancelTourConfirmationModal = ({
  event,
  onClose,
  onCancelTourConfirmationClick,
}: CancelTourConfirmationModalProps) => {
  return (
    <Modal
      aria-label="Cancel tour confirmation"
      open={true}
      onOpenChange={(open) => !open && onClose()}
      body={
        <div data-testid="CancelTourConfirmationModal-Body">
          <Heading css={{ marginBottom: 'default' }} level={4} fontFamily="heading-alt">
            Cancel this tour?
          </Heading>
          <Paragraph css={{ marginBottom: 'tighter' }}>
            This will let {event.bookedByName} know that the tour scheduled for {getEventToastDisplayDate(event)} is
            canceled.
          </Paragraph>
        </div>
      }
      footer={
        <ButtonGroup aria-label="modal actions">
          <Button onClick={onClose}>Go back</Button>
          <Button
            data-testid="CancelTourConfirmationModal-CancelBtn"
            emphasis="filled"
            tone="critical"
            onClick={onCancelTourConfirmationClick}
          >
            Cancel tour
          </Button>
        </ButtonGroup>
      }
      size={{ base: 'fullScreen', lg: 'md' }}
    />
  );
};

export default CancelTourConfirmationModal;
